export default {
    studentLessons: [],
    studentTexts: [],
    studentActivitiesReply: [],
    studentActivitiesNoReply: []
}